<template>
  <div id='main' class="touch mw9 center" :class="[loggedIn ? 'private' : 'public']">

    <header v-if="loggedIn">
      <nav-bar @side-nav-toggle="sideNavToggle" class="h-100 w-100"/>
    </header>

    <aside v-if="loggedIn" :class="[sideNavStyle, loggedIn ? '' : 'aside-hidden' ]">
      <side-nav @hide="sideNavVisible = false"/>
    </aside>

    <!--
    Когда изменяется маршрут и роутером асинхронно грузится новый view, старый view все еще отображается,
    так вот этим условием мы скрываем старый view
    -->
    <main v-if="!$store.getters['router/routing']">
      <router-view/>
    </main>

    <portal-target name="modals"></portal-target>

    <notifications/>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import SideNav from '@/components/SideNav.vue'
import Notifications from '@/components/notifications/Notifications.vue'

export default {
  components: {
    NavBar,
    SideNav,
    Notifications
  },
  data () {
    return {
      sideNavVisible: false
    }
  },
  computed: {
    sideNavStyle () {
      return (this.sideNavVisible ? 'show-side-nav' : 'hide-side-nav')
    },
    loggedIn () {
      return this.$store.getters['user/loggedIn']
    }
  },
  methods: {
    sideNavToggle () {
      this.sideNavVisible = !this.sideNavVisible
    }
  }
}
</script>

<style lang="scss" scoped>

.hide-side-nav {
  -webkit-transform: translate3d( -100%, 0, 0 );
  transform: translate3d( -100%, 0, 0 );
  -webkit-transition: transform 0.15s linear;
  transition: transform 0.15s linear;
}
.show-side-nav {
  -webkit-transform: translate3d( 0, 0, 0 );
  transform: translate3d( 0, 0, 0 );
  -webkit-transition: transform transform 0.15s ease-out;
  transition: transform 0.15s ease-out;
}

@media screen and (min-width: 60em) {
  .hide-side-nav, .show-side-nav {
    -webkit-transform: translate3d( 0, 0, 0 );
    transform: translate3d( 0, 0, 0 );
    -webkit-transition: transform 0s linear;
    transition: transform 0s linear;
  }
}

.public {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 100vh;
  grid-template-areas:
    "main"
}

.private {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 60px auto;
  grid-template-areas:
    "header"
    "main"
}

@media screen and (min-width: 60em) {
  .private {
    display: grid;
    grid-template-columns: 250px 1fr;
    grid-template-rows: 60px auto;
    grid-template-areas:
      "sidebar header"
      "sidebar main"
  }
}

header {
  grid-area: header;
}

main {
  grid-area: main;
}

aside {
  grid-area: sidebar;
  position: fixed;
  width: 250px;
  height: 100vh;
  z-index: 600;
}
.aside-hidden {
  display: none;
}
</style>
